var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66709 7.75L9.85311 10.936C9.93446 11.0174 10.0664 11.0174 10.1477 10.936L13.3338 7.75L14.2176 8.63388L11.0316 11.8199C10.4621 12.3894 9.53874 12.3894 8.96922 11.8199L5.7832 8.63388L6.66709 7.75Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandMore);
export default __webpack_public_path__ + "static/media/icon_expand_more.589d66a56929776eabaf999bc5119078.svg";
export { ForwardRef as ReactComponent };